/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Insights icon.
 */
export const ICON_CAPABILITY_INSIGHTS = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_788_53680)">
      <path
        clipRule="evenodd"
        d="M29.1353 45.3907C27.4863 45.7852 25.7665 45.9938 24 45.9938C22.2335 45.9938 20.5137 45.7852 18.8647 45.3907C18.0591 45.1979 17.5622 44.3885 17.7549 43.5828C17.9477 42.7771 18.7571 42.2803 19.5628 42.473C20.9848 42.8133 22.4704 42.9938 24 42.9938C25.5297 42.9938 27.0152 42.8133 28.4372 42.473C29.2429 42.2803 30.0523 42.7771 30.2451 43.5828C30.4379 44.3885 29.941 45.1979 29.1353 45.3907ZM14.569 42.2614C14.1355 42.9673 13.2118 43.1882 12.5059 42.7547C9.55164 40.9405 7.05948 38.4484 5.24533 35.4942C4.81182 34.7882 5.03267 33.8645 5.73862 33.431C6.44456 32.9975 7.36827 33.2183 7.80179 33.9243C9.36918 36.4767 11.5233 38.6308 14.0757 40.1982C14.7817 40.6317 15.0025 41.5555 14.569 42.2614ZM33.431 42.2614C32.9975 41.5555 33.2183 40.6317 33.9243 40.1982C36.4767 38.6308 38.6309 36.4767 40.1982 33.9243C40.6318 33.2183 41.5555 32.9975 42.2614 33.431C42.9674 33.8645 43.1882 34.7882 42.7547 35.4942C40.9406 38.4484 38.4484 40.9405 35.4942 42.7547C34.7882 43.1882 33.8645 42.9673 33.431 42.2614Z"
        fill="#1D9BE2"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M44.4938 25.5C43.6653 25.5 42.9938 24.8284 42.9938 24C42.9938 13.51 34.49 5.00622 24 5.00623C13.51 5.00623 5.00622 13.51 5.00623 24C5.00623 24.8284 4.33465 25.5 3.50623 25.5C2.6778 25.5 2.00623 24.8284 2.00623 24C2.00622 11.8532 11.8532 2.00623 24 2.00623C36.1468 2.00622 45.9938 11.8532 45.9938 24C45.9938 24.8284 45.3222 25.5 44.4938 25.5Z"
        fill="#1D9BE2"
        fillRule="evenodd"
      />
      <path
        d="M4.41717 30.245C3.61149 30.4378 2.80208 29.9409 2.60931 29.1352C2.21479 27.4863 2.00623 25.7665 2.00623 24C2.00623 22.2335 2.21479 20.5137 2.60931 18.8647C2.80208 18.059 3.61148 17.5621 4.41717 17.7549C5.22286 17.9477 5.71973 18.7571 5.52697 19.5628C5.18674 20.9848 5.00623 22.4703 5.00623 24C5.00623 25.5297 5.18674 27.0152 5.52697 28.4372C5.71973 29.2429 5.22286 30.0523 4.41717 30.245Z"
        fill="#1D9BE2"
      />
      <path
        d="M43.5828 30.245C42.7771 30.0523 42.2803 29.2429 42.473 28.4372C42.8133 27.0152 42.9938 25.5297 42.9938 24C42.9938 22.4703 42.8133 20.9848 42.473 19.5628C42.2803 18.7571 42.7771 17.9477 43.5828 17.7549C44.3885 17.5621 45.1979 18.059 45.3907 18.8647C45.7852 20.5137 45.9938 22.2335 45.9938 24C45.9938 25.7665 45.7852 27.4863 45.3907 29.1352C45.1979 29.9409 44.3885 30.4378 43.5828 30.245Z"
        fill="#1D9BE2"
      />
      <path
        clipRule="evenodd"
        d="M24.0001 39.9999C32.8366 39.9999 40 32.8365 40 24C40 15.1635 32.8366 8.00006 24.0001 8.00006C15.1635 8.00006 8.00012 15.1635 8.00012 24C8.00012 32.8365 15.1635 39.9999 24.0001 39.9999ZM17.2096 20.4791H16.9582C15.9899 20.4791 15.1977 21.2713 15.1977 22.2396V31.0419C15.1977 32.0101 15.9899 32.8023 16.9582 32.8023H17.2096C18.1779 32.8023 18.9701 32.0101 18.9701 31.0419V22.2396C18.9701 21.2713 18.1779 20.4791 17.2096 20.4791ZM25.7605 16.9582C25.7605 15.9899 24.9682 15.1977 24 15.1977C23.0317 15.1977 22.2395 15.9899 22.2395 16.9582V31.0419C22.2395 32.0101 23.0317 32.8023 24 32.8023C24.9682 32.8023 25.7605 32.0101 25.7605 31.0419V16.9582ZM32.8023 27.018C32.8023 26.0497 32.0101 25.2575 31.0418 25.2575C30.0736 25.2575 29.2814 26.0497 29.2814 27.018V31.0419C29.2814 32.0101 30.0736 32.8023 31.0418 32.8023C32.0101 32.8023 32.8023 32.0101 32.8023 31.0419V27.018Z"
        fill="#1D9BE2"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_788_53680">
        <rect fill="white" height="44" transform="translate(2 2)" width="44" />
      </clipPath>
    </defs>
  </svg>
);
